<span
  class="mat-mdc-button-persistent-ripple"
  [class.mdc-button__ripple]="!_isFab"
  [class.mdc-fab__ripple]="_isFab"
></span>

<ng-content
  select=".material-icons:not([iconPositionEnd]), mat-icon:not([iconPositionEnd]), [matButtonIcon]:not([iconPositionEnd]), .material-symbols-outlined:not([iconPositionEnd]), .material-symbols-rounded:not([iconPositionEnd]), .material-symbols-sharp:not([iconPositionEnd])"
>
</ng-content>

<span class="mdc-button__label"><ng-content></ng-content></span>

<ng-content
  select=".material-icons[iconPositionEnd], mat-icon[iconPositionEnd], [matButtonIcon][iconPositionEnd], .material-symbols-outlined[iconPositionEnd], .material-symbols-rounded[iconPositionEnd], .material-symbols-sharp[iconPositionEnd]"
>
</ng-content>

@if (showProgress()) {
  <div class="mat-mdc-button-progress-indicator-container">
    <ng-content select="[progressIndicator]" />
  </div>
}

<!--
  The indicator can't be directly on the button, because MDC uses ::before for high contrast
  indication and it can't be on the ripple, because it has a border radius and overflow: hidden.
-->
<span class="mat-focus-indicator"></span>

<span class="mat-mdc-button-touch-target"></span>
